import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GET_USER_MEMBER_CLASS, LOGIN_MESSAGE_BOARD_THREADS_NEW, MESSAGE_BOARD_THREADS_SHOW,
} from 'manager/http-constants';
import { forkJoin } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {CONSTANT, IMAGE_EXTENSION, LOADING_KEY, NUMBER} from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../platform.component';
import {SESSION_KEY} from '../../../shared/constant/session-constants';
import { LoginService } from 'src/app/shared/service/login.service';

@Component({
  selector: 'app-l301',
  templateUrl: './l301.component.html',
  styleUrls: ['./l301.component.scss', '../platform.component.scss'],
})

/**
 * 掲示板スレッド登録(L301)
 * 掲示板スレッド登録確認(L302)
 */
export class L301Component extends PlatformComponent {
  // 画面.入力フォーム
  l301InputForm: FormGroup = this.formBuilder.group({
    // タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'message_board_threads',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 書き込み
    content: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'message_board_posts',
          'content',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 匿名
    is_anonymous: this.formBuilder.control(NUMBER.ONE, {
      asyncValidators: [
        this.validator.CheckValidator(
          'message_board_threads',
          'is_anonymous',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
  });

  // 画面.検索フォーム
  l301SearchForm: FormGroup = this.formBuilder.group({
    member_id: this.loginUser ? this.loginUser.member_id : '0'
  });

  // 掲示板スレッドIDを格納
  threadId: string = this.route.snapshot.queryParams.thread_id;

  // 編集時に既存データを保持
  searchResultsList: any;

  // tslint:disable-next-line:variable-name
  private _isAnonymousChecked = true;

  // 確認画面表示フラグ(true=分科会申請登録確認(E205),false=分科会申請登録(E204))
  confirmationFlag = false;

  retouchFlg = false;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private loginService: LoginService,
    private messageData: MessageData
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを掲示板スレッド登録(L301)に変更する
    this.router.navigate(['pages/platform/l301/' + this.inputType], {
      queryParams: {
        screenId: 'l301',
        article_id: this.threadId,
      },
    });
  }

  ngOnInit(): void {
    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット

      // ログイン状態を判定
      if (response) {
        // ログイン状態の場合

        /* ログインユーザー情報 */
        // セッションからログインユーザ情報取得
        const loginUser = JSON.parse(
          window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
        );

        // セッションにログインユーザ情報が存在するか否か
        if (loginUser) {
          // セッションにログインユーザが存在する場合

          console.log('セッションにログインユーザが存在する場合');
          this.checkMemberClass();
          return;
        } else {
          // セッションにログインユーザが存在しない場合(初回表示時)

          // ログインユーザ情報取得処理
          this.loginService.getLoginUser().subscribe((res) => {
            // 正常なユーザの為、セッションにユーザ情報を格納
            window.sessionStorage.setItem(
              SESSION_KEY.loginUserInformation,
              JSON.stringify(res.body[0])
            );

            this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));

            console.log('セッションにログインユーザが存在しない場合(初回表示時)');
            this.checkMemberClass();
            return;
          });
        }
      } else {
        // 未ログイン状態の場合
        console.log('未ログイン状態の為、一覧に戻す');

        this.loginUser = null;

        this.router.navigate(['pages/platform/l101']);
        return;
      }
    });

    // 辞書値リストを取得
    this.getSpecCodeList(1004);

    // 編集初期表示
    this.setEditInitialData();
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if ((GENERATE_INPUT_TYPE.NEW == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MESSAGE_BOARD_THREADS_SHOW);

    const l301SearchForm: any = JSON.parse(
      JSON.stringify(this.l301SearchForm.value)
    );

    // 掲示板スレッド詳細を取得
    this.dbOperationService
      .getNoTemplateData(MESSAGE_BOARD_THREADS_SHOW + this.threadId, l301SearchForm, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MESSAGE_BOARD_THREADS_SHOW);
        if (this.commonService.checkNoneResponse(response)) {
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.l301InputForm,
          response.body
        );

        // 検索結果を保持
        this.searchResultsList = response.body;
      });
  }

  /**
   * 会員種類をチェック
   */
  private checkMemberClass(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(GET_USER_MEMBER_CLASS);

    // 掲示板スレッド詳細を取得
    this.dbOperationService
      .getNoTemplateData(GET_USER_MEMBER_CLASS + this.getLoginUserId(), {}, false)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, GET_USER_MEMBER_CLASS);
        if (this.commonService.checkNoneResponse(response)) {
          return;
        } else {
          const res = response.body;
          if (res.class_id == 3) {
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.T00015),
                detail: this.commonService.msg(MESSAGE_CODE.E00037),
              })
            );
            this.router.navigate(['pages/platform/l101']);
          }
        }
      });
  }

  /**
   * 掲示板スレッド登録(L301)を表示する
   */
  public moveL301(): void {
    // 掲示板スレッド登録(L301)へ遷移
    this.router.navigate(['pages/platform/l301/' + this.inputType], {
      queryParams: {
        screenId: 'l301',
        information_id: this.threadId,
      },
    });

    // 掲示板スレッド登録(L301)を表示する
    this.confirmationFlag = false;

    // 修正フラグを立てる
    this.retouchFlg = true;
  }

  /**
   * 掲示板スレッド登録確認(J204)を表示する
   */
  public moveL302(): void {
    // 表示する
    this.confirmationFlag = true;

    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const l301InputForm: any = JSON.parse(
      JSON.stringify(this.l301InputForm.value)
    );

    // console.log('l301InputForm', l301InputForm);

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    const task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'message_board_threads',
        l301InputForm
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 掲示板スレッド登録確認(G104)へ遷移
      this.router.navigate(
        ['pages/platform/l301/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'l302',
          },
        }
      );

      // 掲示板スレッド登録確認(G104)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 掲示板スレッド登録完了(G105)へ遷移する
   */
  public moveL303(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const l301InputForm: any = JSON.parse(
      JSON.stringify(this.l301InputForm.value)
    );

    l301InputForm.is_anonymous = this.isAnonymousChecked;

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // 掲示板スレッド登録を実施
      this.dbOperationService
        .insertData(LOGIN_MESSAGE_BOARD_THREADS_NEW, this.l301InputForm.value)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 掲示板スレッド登録完了(G105)へ遷移
            this.router.navigate(['pages/platform/l201', response.body.thread_id]);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 掲示板スレッド登録(L301)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集の場合

      // 掲示板スレッド更新を実施
      this.dbOperationService
        .updateData(
          LOGIN_MESSAGE_BOARD_THREADS_NEW,
          this.threadId,
          this.l301InputForm.value
        )
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 掲示板スレッド登録完了(G105)へ遷移
            this.router.navigate(['pages/platform/l303']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 掲示板スレッド登録(L301)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }

  get isAnonymousChecked(): boolean {
    return this._isAnonymousChecked;
  }

  set isAnonymousChecked(value: boolean) {
    this._isAnonymousChecked = value;
    this.l301InputForm.get('is_anonymous')?.setValue(value ? 1 : 0);
  }

  onAnonymousChange(event: any): void {
    const isChecked = event.checked;
    this.isAnonymousChecked = isChecked;
  }
}
